__webpack_require__.p = "https://ua-users-management-frontend.studyportals.eu/dist/";